import { makeStyles } from '@material-ui/core'
import { colors } from '../../Themes'

const customerModalFeedbackStyles = makeStyles((theme) => ({
  paperCostum: {
    position: 'relative',
    padding: '24px ',
    maxWidth: 450,
    borderRadius: 5,
    [theme.breakpoints.down('sm')]: {
      padding: 25,
      margin: '0 10px',
    },
  },
  
  ModalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
  },
  spaceText: {
    margin: '22px 0 15px 0'
  },
  spaceText2: {
    margin: '17px 0 0px 0'
  
  },
  spaceTittle: {
    marginTop: 16,
    alignSelf: 'center'
  },
  resendCode: {
    color: colors.primary,
    textDecoration: 'underline',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '48px 0'
  },
  errorInput: {
    color: colors.secondary,
    padding: '0 12px',
    fontSize: 16,
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 30,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginTop: 20,
  
    },
  },
  cancelButton: {
    flex: '0 0 40%',
    backgroundColor: colors.white,
    border: '1px solid #cccccc',
    color: colors.primary,
    '&:hover': {
      backgroundColor: colors.grayHover,
      color: colors.white
    },
  },
  nextButton: {
    flex: '0 0 40%',
    [theme.breakpoints.down('sm')]: {
      marginTop: 12
    },
  
  },
}))

export default customerModalFeedbackStyles